export default ({ request }) => ({
    systemDictionaryListApi(data = {}) {
      return request({
        url: '/sys/systemDictionary/list',
        method: 'post',
        data,
      })
    },
    systemDictionaryDetailApi(data = {}) {
        return request({
          url: '/sys/systemDictionary/detail',
          method: 'post',
          data,
        })
      },
      systemDictionarySaveApi(data = {}) {
        return request({
          url: '/sys/systemDictionary/save',
          method: 'post',
          data,
        })
      },  
      systemDictionaryDelApi(data = {}) {
        return request({
          url: '/sys/systemDictionary/del',
          method: 'post',
          data,
        })
      }, 
      systemDictionaryRefreshRedisApi(data = {}) {
        return request({
          url: '/sys/systemDictionary/refreshRedis',
          method: 'post',
          data,
          timeout: 60000,
        })
      }, 
  })
  